import { toast } from "sonner";

// After a merge / link: tell the owner what was left for the Packaging review queue, with a direct link. Nothing here changes data.
export function notifyMergeUnits(units, navigate) {
  if (!units) return;
  const flagged = units.flagged_for_review || 0;
  const kept = units.kept_own_packaging || [];
  if (!flagged && !kept.length) return;
  const parts = [];
  if (kept.length) parts.push(`${kept.length} product${kept.length === 1 ? " keeps" : "s keep"} its own packaging (${kept.map((k) => `${k.description}: ${k.packaging}`).join("; ")})`);
  if (flagged) parts.push(`${flagged} historical invoice line${flagged === 1 ? "" : "s"} with different packaging left for review`);
  toast.warning(parts.join(" · "), {
    duration: 12000,
    description: "Nothing was overwritten. Approve or keep each line in Packaging review.",
    action: { label: "Open Packaging review", onClick: () => (navigate ? navigate("/packaging-review") : window.location.assign("/packaging-review")) },
  });
}
